import { render } from "./MenuItens.vue?vue&type=template&id=7c05920f&scoped=true"
import script from "./MenuItens.vue?vue&type=script&lang=js"
export * from "./MenuItens.vue?vue&type=script&lang=js"

import "./MenuItens.vue?vue&type=style&index=0&id=7c05920f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Murilo\\Documents\\app-construp-cms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c05920f"]])

export default __exports__